export class Department {
	area: number;
	company: number;
	head: number
	id:number
	name:string
}

export class AdminDepartmentRequest {
	area?: number;
	company?:number;
	name: string;
	head?:any;
	id?:number;
}